// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u8wu","footer":"styles_footer__XWCy4","passCodeTooltip":"styles_passCodeTooltip__3eJ0V"};